// org_ids contains the list of all the organisations who want the description to be shown as default in the tasks table 
export const specialOrgIds = [16];